module.exports = __webpack_public_path__ + "img/collection-weddingRingsPalladium@2x.75532dc.jpg";